import React from 'react'
import loadable from '@loadable/component'

import Layout from '../layout/layout'

function Loading() {
  return <div>Loading...</div>
}

//= ====================================================================
//                                Dashboard
//= ====================================================================
const Dashboard = loadable(() => import('features/dashboard/dashboard'), {
  fallback: <Loading />,
})
//= ====================================================================
//                                Devices
//= ====================================================================
const Devices = loadable(() => import('features/devices/device-dashboard'), {
  fallback: <Loading />,
})

//= ====================================================================
//                                 Panic
//= ====================================================================
const OngoingDashboard = loadable(
  () => import('features/panic/ongoing-dashboard'),
  { fallback: <Loading /> }
)
const OngoingLiveFeed = loadable(
  () => import('features/panic/ongoing-live-feed'),
  { fallback: <Loading /> }
)
const Resolved = loadable(() => import('features/panic/resolved-dashboard'), {
  fallback: <Loading />,
})
const ResolvedHistory = loadable(
  () => import('features/panic/resolved-history'),
  { fallback: <Loading /> }
)
//= ====================================================================
//                                Profile
//= ====================================================================
const Profile = loadable(() => import('features/profile/profile'), {
  fallback: <Loading />,
})
//= ====================================================================
//                                Reports
//= ====================================================================
const ActiveSitRep = loadable(() => import('features/sit-rep/active-sitrep'), {
  fallback: <Loading />,
})
const ActiveReport = loadable(
  () => import('features/sit-rep/outlets/active-report'),
  { fallback: <Loading /> }
)
const ArchivedSitRep = loadable(
  () => import('features/sit-rep/archived-sitrep'),
  {
    fallback: <Loading />,
  }
)
const ArchivedReport = loadable(
  () => import('features/sit-rep/outlets/archived-report'),
  { fallback: <Loading /> }
)
//= ====================================================================
//                                Telegram
//= ====================================================================
const TelegramDashboard = loadable(
  () => import('features/telegram/telegram.dashboard'),
  { fallback: <Loading /> }
)

const TelegramChannelSettings = loadable(
  () => import('features/telegram/telegram.channel-settings'),
  { fallback: <Loading /> }
)
//= ====================================================================
//                                Access Token
//= ====================================================================
const AccessTokenDashboard = loadable(
  () => import('features/access-token/acces-token.dashboard'),
  { fallback: <Loading /> }
)
//= ====================================================================
//                                Contract
//= ====================================================================
const ContractDashboard = loadable(
  () => import('features/contract/contract.dashboard'),
  { fallback: <Loading /> }
)

//= ====================================================================
//                                Summons
//= ====================================================================
const IssuedDashboard = loadable(
  () => import('features/summons/issued/issued-dashboard'),
  { fallback: <Loading /> }
)
const IssuedHistory = loadable(
  () => import('features/summons/issued/issued-history'),
  { fallback: <Loading /> }
)
const IssuedPrintPreview = loadable(
  () => import('features/summons/issued/issued-print-preview'),
  { fallback: <Loading /> }
)
const RejectedDashboard = loadable(
  () => import('features/summons/rejected/rejected-dashboard'),
  { fallback: <Loading /> }
)
const RejectedHistory = loadable(
  () => import('features/summons/rejected/rejected-history'),
  { fallback: <Loading /> }
)
const VerifiedDashboard = loadable(
  () => import('features/summons/verified/verified-dashboard'),
  { fallback: <Loading /> }
)
const VerifiedHistory = loadable(
  () => import('features/summons/verified/verified-history'),
  { fallback: <Loading /> }
)
const TrafficOffences = loadable(
  () => import('features/summons/offences/traffic-offences'),
  { fallback: <Loading /> }
)

//= ====================================================================
//                                Touring
//= ====================================================================
const HistoryDashboard = loadable(
  () => import('features/touring/history/history-dashboard'),
  { fallback: <Loading /> }
)
const HistoryRecord = loadable(
  () => import('features/touring/history/history-record'),
  { fallback: <Loading /> }
)
const HistoryInTourReport = loadable(
  () => import('features/touring/history/history-in-tour-report'),
  { fallback: <Loading /> }
)
const HistoryPrintPreview = loadable(
  () => import('features/touring/history/history-print-preview'),
  { fallback: <Loading /> }
)
const LiveTouring = loadable(
  () => import('features/touring/live/live-tour-dashboard'),
  { fallback: <Loading /> }
)
const LiveTourMonitoring = loadable(
  () => import('features/touring/live/live-tour-feed'),
  { fallback: <Loading /> }
)
const SummaryReport = loadable(
  () => import('features/touring/summary/summary-report'),
  {
    fallback: <Loading />,
  }
)
const HistoryStatistic = loadable(
  () => import('features/touring/statistics/statistic'),
  { fallback: <Loading /> }
)

//= ====================================================================
//                                Users
//= ====================================================================
const UsersDashboard = loadable(
  () => import('features/users/users-dashboard'),
  { fallback: <Loading /> }
)
const UserAccount = loadable(() => import('features/users/user-account'), {
  fallback: <Loading />,
})
const UserRegistration = loadable(
  () => import('features/users/user-registration'),
  { fallback: <Loading /> }
)

//= ====================================================================
//                                ZoneList
//= ====================================================================
const ZonesDashboard = loadable(
  () => import('features/zones/zones-dashboard'),
  { fallback: <Loading /> }
)

// { path: '/', exact: true, name: 'Home', component: PrivateLayout },
// https://github.com/ReactTraining/react-router/tree/master/packages/react-router-config
const routes = [
  { path: '/', exact: true, name: 'Home', component: Layout },
  { path: '/dashboard', exact: true, name: 'Dashboard', component: Dashboard },
  { path: '/users', exact: true, name: 'Users', component: UsersDashboard },
  {
    path: '/users/details',
    exact: true,
    name: 'Detail',
    component: UserAccount,
  },
  {
    path: '/users/add',
    exact: true,
    name: 'Add User',
    component: UserRegistration,
  },
  { path: '/devices', exact: true, name: 'Devices', component: Devices },
  { path: '/zones', exact: true, name: 'Premises', component: ZonesDashboard },

  { path: '/profile', exact: true, name: 'Profile', component: Profile },

  { path: '/touring/live', exact: true, name: 'Live', component: LiveTouring },
  {
    path: '/touring/live/details',
    exact: true,
    name: 'Active',
    component: LiveTourMonitoring,
  },
  {
    path: '/touring/history',
    exact: true,
    name: 'Tour History',
    component: HistoryDashboard,
  },
  {
    path: '/touring/summary',
    exact: true,
    name: 'Tour Summary',
    component: SummaryReport,
  },
  {
    path: '/touring/history/details',
    exact: true,
    name: 'Log',
    component: HistoryRecord,
  },
  {
    path: '/touring/history/details/report',
    exact: true,
    name: 'Report',
    component: HistoryInTourReport,
  },
  {
    path: '/touring/history/historyprint',
    exact: true,
    name: 'History Print',
    component: HistoryPrintPreview,
  },
  {
    path: '/touring/report',
    exact: true,
    name: 'Tour Report',
    component: HistoryStatistic,
  },
  {
    path: '/reports/active',
    exact: true,
    name: 'Active Reports',
    component: ActiveSitRep,
  },
  {
    path: '/reports/active/view',
    exact: true,
    name: 'View',
    component: ActiveReport,
  },
  {
    path: '/reports/archived',
    exact: true,
    name: 'Archived Reports',
    component: ArchivedSitRep,
  },
  {
    path: '/reports/archived/view',
    exact: true,
    name: 'View',
    component: ArchivedReport,
  },

  {
    path: '/panic/ongoing',
    exact: true,
    name: 'Ongoing Panics',
    component: OngoingDashboard,
  },
  {
    path: '/panic/ongoing/details',
    exact: true,
    name: 'Active',
    component: OngoingLiveFeed,
  },
  {
    path: '/panic/resolved',
    exact: true,
    name: 'Resolved Panics',
    component: Resolved,
  },
  {
    path: '/panic/resolved/details',
    exact: true,
    name: 'Log',
    component: ResolvedHistory,
  },
  {
    path: '/access-token',
    exact: true,
    name: 'Access Token',
    component: AccessTokenDashboard,
  },
  {
    path: '/contract',
    exact: true,
    name: 'Contract',
    component: ContractDashboard,
  },
]

const getPrivateRoutes = ({ summon, telegram }) => {
  if (summon) {
    routes.push({
      path: '/offences',
      exact: true,
      name: 'Compounds Offences',
      component: TrafficOffences,
    })

    routes.push({
      path: '/traffic/issued',
      exact: true,
      name: 'Compounds Issued',
      component: IssuedDashboard,
    })
    routes.push({
      path: '/traffic/issued/details',
      exact: true,
      name: 'Info',
      component: IssuedHistory,
    })
    routes.push({
      path: '/traffic/issued/print',
      exact: true,
      name: 'Info',
      component: IssuedPrintPreview,
    })
    routes.push({
      path: '/traffic/verified',
      exact: true,
      name: 'Compounds Verified',
      component: VerifiedDashboard,
    })
    routes.push({
      path: '/traffic/verified/details',
      exact: true,
      name: 'Info',
      component: VerifiedHistory,
    })

    routes.push({
      path: '/traffic/archived',
      exact: true,
      name: 'Compounds Archived',
      component: RejectedDashboard,
    })
    routes.push({
      path: '/traffic/archived/details',
      exact: true,
      name: 'Info',
      component: RejectedHistory,
    })
  }
  if (telegram) {
    routes.push({
      path: '/telegram',
      exact: true,
      name: 'Telegram',
      component: TelegramDashboard,
    })
    routes.push({
      path: '/telegram/:channelId/channel',
      exact: true,
      name: 'Channel Settings',
      component: TelegramChannelSettings,
    })
  }
  return routes
}

export default getPrivateRoutes
